import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import { AxiosError } from "axios";
import toastMessages from "../../helpers/toastMessage";
import { useHistory } from "react-router-dom";

interface AuthorizedDocumentFile {
  filePath: string;
  orderId: string;
}

interface AddAuthorizedDocumentsPayload {
  files: AuthorizedDocumentFile[];
}

function useAddAuthorizedDocuments() {
  const { authState } = useOktaAuth();
  const queryClient = useQueryClient();
  const history = useHistory();

  return useMutation({
    mutationKey: ["addAuthorizedDocuments"],
    mutationFn: (data: AddAuthorizedDocumentsPayload) => {
      return axiosInstance.post(
        "v1/orders/new-flow/add-authorized-documents",
        data,
        {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        }
      );
    },
    onSuccess: () => {
      history.push("/access/approvals/order-authorized");
      queryClient.invalidateQueries({ queryKey: ["testOrdersList"] });
    },
    onError: (error: AxiosError<any, any>) => {
      const errorMessage =
        error?.response?.data?.message ?? "Authorization using pdf failed";
      toastMessages.error(errorMessage);
    },
  });
}

export default useAddAuthorizedDocuments;
